import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-meteorologe',
  templateUrl: './meteorologe.component.html',
  styleUrls: ['./meteorologe.component.css']
})
export class MeteorologeComponent  {


}
